import { isNumeric } from "./number";

export function compareEntities(entityA, entityB) {
   if (!entityA || !entityB) return false;

   if (typeof entityA === 'object' && typeof entityB === 'object') {
      return entityA.externalId === entityB.externalId;
   }

   if (isNumeric(entityA) && typeof entityB === 'object') {
      return Number(entityA) === Number(entityB.id);
   }

   if (typeof entityA === 'object' && isNumeric(entityB)) {
      return Number(entityA.id) === Number(entityB);
   }

   return entityA === entityB;
}

export function compareEntityArrays(arr1, arr2) {
   if (
      !arr1 ||
      !arr2 ||
      arr1.length !== arr2.length
   ) {
      return false;
   }
   return arr1.every(it => arr2.find(it2 => compareEntities(it, it2)));
}